import '../ReusableComponents/ModulePage.css';
import SectionButtons from '../ReusableComponents/SectionButtons';
import React, { Component } from 'react';
import { can, unrestricted } from '../../permissions';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdEvent, MdCheck, MdContentCopy, MdCopyAll, MdOutlineRule, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import Processo from '../Processo/Processo';
import Corretores from '../Corretores/Corretores';
import Fiscais from '../Fiscais/Fiscais';
import Alunos from '../Alunos/Alunos';
import ModalTermos from './ModalTermos';
import './label.css';
import CandidatosConflitos from '../CandidatosConflitos/CandidatosConflitos';
import Avaliadores from '../Avaliador/Avaliadores';
import Treinamentos from '../Treinamentos/TreinamentosInstituicao';
import FaculdadeConfiguracoes from "../FaculdadeConfiguracoes/FaculdadeConfiguracoes";

class ShowFaculdade extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            caminho: '',
            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,
            faculdade: {},
            activeTab: 0,
            show_more: false,
            copy_api_key: false,
            copy_secret_key: false
        };

    }


    get_faculdade(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_faculdade/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, faculdade: resp.faculdade
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }






    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });
        else if (tab === null) this.setState({ activeTab: 0 });
        this.get_faculdade(this.props.match.params.id);
    }

    getTabIndex = (tabName) => {
        let index = 0;
        const tabs = [
            'processos', // 0
            'corretores', // 1
            'fiscais', // 2
            'avaliadores', // 3
            'candidatos', // 4
        ];
        
        index = tabs.length; // 5
        
        if (this.props.user?.empresa?.plan?.training == true) {
            if (tabName === 'treinamentos') return index;
            index++;
        }
        
        if (tabName === 'configuracoes') return index;
        
        return index;
    }

    componentDidUpdate(previousProps) {
        if (previousProps.location.search !== this.props.location.search) {
            const tab = Number(new URLSearchParams(this.props.location.search).get('tab') || 0);
            if (tab !== this.state.activeTab) this.setState({ activeTab: tab });
        }
    }

    render() {
        const allowedTabs = ["processo_seletivo", "corretores", "fiscais", "avaliadores", "candidatos"].map(module => !module || can(this.props.user, module));
        if (this.props.user?.empresa?.plan?.training) allowedTabs[5] = unrestricted(this.props.user);
        allowedTabs[this.getTabIndex('configuracoes')] = can(this.props.user, 'processo_seletivo', 'edit');
        const selectedTab = allowedTabs[this.state.activeTab] ? this.state.activeTab : allowedTabs.findIndex(Boolean);
        const sections = [
{ value: 0, label: this.props.user?.empresa?.change_text ? 'Vagas/Cargos' : 'Processos Seletivos', description: this.props.user?.empresa?.change_text ? 'Gerencie as vagas do processo seletivo.' : 'Gerencie os processos seletivos da instituição.', icon: 'processos', visible: allowedTabs[0] },
{ value: 1, label: 'Corretores', description: 'Cadastre e consulte os corretores.', icon: 'corretores', visible: allowedTabs[1] },
{ value: 2, label: 'Fiscais', description: 'Cadastre e consulte os fiscais.', icon: 'fiscais', visible: allowedTabs[2] },
{ value: 3, label: 'Avaliadores', description: 'Cadastre e consulte os avaliadores.', icon: 'avaliadores', visible: allowedTabs[3] },
{ value: 4, label: 'Candidatos', description: 'Cadastre e consulte os candidatos.', icon: 'candidatos', visible: allowedTabs[4] },
{ value: this.getTabIndex('treinamentos'), label: 'Treinamentos', description: 'Acesse os treinamentos da equipe.', icon: 'treinamentos', visible: !!this.props.user?.empresa?.plan?.training && allowedTabs[5] },
{ value: 'portal', label: 'Inscrições', description: 'Configure as inscrições e acompanhe candidatos.', icon: 'candidatos', href: `/instituicao/portal/${this.state.faculdade.portal_empresa_id}/inscricoes?ontest_faculdade_id=${this.state.faculdade.id}`, visible: !!this.state.faculdade.portal_enabled && !!this.state.faculdade.portal_company_enabled && can(this.props.user,'portal_inscricoes') },
{ value: 'relatorios', label: 'Relatórios', description: 'Acesse o dashboard, os indicadores e as planilhas.', icon: 'relatorios', href: `/instituicao/dashboard/${this.state.faculdade.id}`, visible: can(this.props.user, 'dashboard_resultados') },
{ value: this.getTabIndex('configuracoes'), label: 'Configurações', description: 'Ajuste os dados e opções da instituição.', icon: 'configuracoes', visible: allowedTabs[this.getTabIndex('configuracoes')] },
];
        const selectedSection = sections.find(item => item.value === selectedTab && item.visible !== false);
        if (this.state.loading_screen) return <SkeletonCoursePage />
        else return (
          <div className="module-page">
            <div className="card module-card module-identity module-institution">
              <div className="card-body">
                <div className="module-heading">
                  {this.state.faculdade.logo && <img className="module-logo" src={this.state.faculdade.logo} alt={`Logo de ${this.state.faculdade.name}`} />}
                  <div className="module-heading-text">
                    <h1>{this.state.faculdade.name}</h1>
                    <p className="module-description">{this.props.user?.empresa?.change_text ? 'Gerencie as vagas, candidatos e equipe do processo.' : 'Gerencie os processos seletivos, candidatos e equipe da instituição.'}</p>
                    {this.state.faculdade.created_at && <div className="module-meta"><MdEvent aria-hidden="true" /> Criada em {moment(this.state.faculdade.created_at).format('DD/MM/YYYY')}</div>}
                  </div>
                  <div className="module-back hidethis"><DefaultButton bg="secondary" text="Voltar" icon={<RiArrowGoBackLine />} to="/" /></div>
                </div>

              </div>
            </div>
            <div className="card module-card module-selector hidethis">
              <div className="card-body">
                <h2 className="module-selector-title hidethis">Escolha um módulo para gerenciar</h2>
                <SectionButtons variant="modules" value={selectedTab} items={sections} onChange={value => {
                      this.setState({ activeTab: value });
                      const params = new URLSearchParams(this.props.location.search);
                      params.set('tab', value);
                      this.props.history.push({ search: `?${params.toString()}` });
                    }} />
              </div>
            </div>
            <div className="card module-card module-content">
              <div className="card-body">
                {selectedSection && <div className="module-content-heading hidethis">
                  <h2>{selectedSection.label}</h2>
                  <p>{selectedSection.description}</p>
                </div>}
                <TabPanel value={selectedTab} index={0}>
                  {allowedTabs[0] && <Processo
                    faculdade_id={this.state.faculdade.id}
                    faculdade_name={this.state.faculdade.name}
                    slug={this.state.faculdade.slug}
                  />}
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                  {allowedTabs[1] && <Corretores
                    faculdade_id={this.state.faculdade.id}
                    faculdade_name={this.state.faculdade.name}
                    slug={this.state.faculdade.slug}
                  />}
                </TabPanel>
                <TabPanel value={selectedTab} index={2}>
                  {/* <AddToCourse/> */}
                  {allowedTabs[2] && this.props.user?.empresa?.online_proccess == true && (
                    <Fiscais
                      faculdade_id={this.state.faculdade.id}
                      faculdade_name={this.state.faculdade.name}
                      slug={this.state.faculdade.slug}
                    />
                  )}
                  {this.props.user?.empresa?.online_proccess == false && (
                    <p style={{ textAlign: "center" }}>Módulo não habilitado</p>
                  )}
                </TabPanel>
                <TabPanel value={selectedTab} index={3}>
                  {/* <AddToCourse/> */}
                  {allowedTabs[3] && this.props.user?.empresa?.online_proccess == true && (
                    <Avaliadores
                      faculdade_id={this.state.faculdade.id}
                      faculdade_name={this.state.faculdade.name}
                      slug={this.state.faculdade.slug}
                    />
                  )}
                  {this.props.user?.empresa?.online_proccess == false && (
                    <p style={{ textAlign: "center" }}>Módulo não habilitado</p>
                  )}
                </TabPanel>
                <TabPanel value={selectedTab} index={4}>
                  {allowedTabs[4] && <Alunos
                    faculdade_id={this.state.faculdade.id}
                    faculdade_name={this.state.faculdade.name}
                    slug={this.state.faculdade.slug}
                  />}
                </TabPanel>
                {this.props.user?.empresa?.plan?.training == true && (
                  <TabPanel
                    value={selectedTab}
                    index={this.getTabIndex("treinamentos")}
                  >
                    {allowedTabs[5] && <Treinamentos
                      faculdade_id={this.state.faculdade.id}
                      faculdade_name={this.state.faculdade.name}
                      slug={this.state.faculdade.slug}
                    />}
                  </TabPanel>
                )}

                {<TabPanel
                  value={selectedTab}
                  index={this.getTabIndex("configuracoes")}
                >
                  {allowedTabs[this.getTabIndex('configuracoes')] && (this.props.user?.empresa?.plan?.training == true ? <FaculdadeConfiguracoes
                    faculdade_id={this.state.faculdade.id}
                    faculdade_name={this.state.faculdade.name}
                    slug={this.state.faculdade.slug}
                  />: <p style={{ textAlign: "center" }}>
                        Módulo não habilitado
                      </p>)}
                </TabPanel>}

                {/* <TabPanel value={selectedTab} index={4}>
                            <CandidatosConflitos faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} slug={this.state.faculdade.slug}/>

                        </TabPanel> */}
              </div>
            </div>
            {this.props.user?.empresa?.online_proccess == true && <section className="card module-card module-integration-footer" aria-label="Integração">
              <div className="card-body">
                <h2 className="module-selector-title hidethis">Integração</h2>
              <div className="module-integration-grid">
                <div className="module-fact"><span className="module-fact-icon" aria-hidden="true">🔑</span><div><span>API Key</span><strong>{this.state.faculdade.apikey || 'Não informada'}</strong><button type="button" className="module-copy" aria-label="Copiar API key" onClick={() => { navigator.clipboard.writeText(this.state.faculdade.apikey || ''); this.setState({ copy_api_key: true }); }}>{this.state.copy_api_key ? <MdCheck /> : <MdContentCopy />}</button></div></div>
                <div className="module-fact"><span className="module-fact-icon" aria-hidden="true">🔒</span><div><span>API Secret</span><strong>{this.state.faculdade.apisecret || 'Não informada'}</strong><button type="button" className="module-copy" aria-label="Copiar API secret" onClick={() => { navigator.clipboard.writeText(this.state.faculdade.apisecret || ''); this.setState({ copy_secret_key: true }); }}>{this.state.copy_secret_key ? <MdCheck /> : <MdContentCopy />}</button></div></div>
                <button type="button" className="module-fact module-fact-action" onClick={() => this.setState({ show_more: true })}><span className="module-fact-icon is-green"><MdOutlineRule aria-hidden="true" /></span><span><span>Termos</span><strong>{this.props.user?.empresa?.change_text ? 'Visualizar termos do processo' : 'Visualizar termos da instituição'}</strong></span></button>
              </div>
              <ModalTermos showModal={this.state.show_more} setShowModal={e => this.setState({ show_more: e })} processo_name={this.state.faculdade.name} termos={this.state.faculdade.termos} />
              </div>
            </section>}
          </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,

    }
);

const SkeletonCoursePage = () => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
                <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>
    );
}

export default connect(mapsStateToProps, { logout })(ShowFaculdade);
